/* Decorative phone layers only animate while the hero is on screen. */
(() => {
  const page=document.querySelector('[data-hero-benefits-version]');
  const hero=page?.querySelector('.ff-hero');
  if(!hero)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const photo=hero.querySelector('.fvs-hero-photo');
  const rail=hero.querySelector('.ff-trust-cloud');
  const intro=hero.querySelector('.fvs-hero-title__intro');
  const header=page.querySelector('.ff-header');
  const headerCta=header?.querySelector('.fvs-header-login');
  let frame=0;
  const portrait=()=>{
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>{
      if(!photo||!rail||!intro||!headerCta)return;
      const bounds=hero.getBoundingClientRect();
      const desktop=matchMedia('(min-width: 900px)').matches;
      // A fixed header is viewport-relative. Use its resting position so a
      // resize/rotation while scrolled cannot collapse the portrait to 280px.
      const restingButtonTop=(parseFloat(getComputedStyle(header).top)||0)+(header.offsetHeight-headerCta.offsetHeight)/2;
      const top=desktop?restingButtonTop-(bounds.top+scrollY):matchMedia('(max-width: 620px)').matches?6:Math.max(6,intro.getBoundingClientRect().top-bounds.top-24);
      photo.style.setProperty('--fvs-portrait-top',`${Math.round(top)}px`);
      photo.style.setProperty('--fvs-portrait-height',`${Math.max(280,Math.round(rail.getBoundingClientRect().top-bounds.top-top-12))}px`);
    });
  };
  if('ResizeObserver' in window){const observer=new ResizeObserver(portrait);[hero,rail,headerCta].filter(Boolean).forEach(el=>observer.observe(el));}
  window.addEventListener('resize',portrait,{passive:true});
  window.addEventListener('pageshow',portrait,{passive:true});
  document.fonts?.ready.then(portrait);
  let visible=true;
  const sync=()=>{
    page.classList.toggle('f9-hero-motion',!reduced.matches);
    page.classList.toggle('f9-hero-visible',visible&&!document.hidden);
  };
  if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:0}).observe(hero);
  reduced.addEventListener('change',sync);
  document.addEventListener('visibilitychange',sync);
  sync();
  portrait();
})();
